import React from 'react';

export function FeedbackSkeleton() {
    return (
        <div className="brutalist-card p-6 animate-fade" data-testid="feedback-skeleton">
            {/* Score skeleton */}
            <div className="text-center mb-6">
                <div className="w-24 h-24 rounded-full skeleton mx-auto" />
                <div className="skeleton skeleton-text w-28 mx-auto mt-3" />
                <div className="skeleton skeleton-text-sm w-20 mx-auto" />
                <div className="skeleton skeleton-text-sm w-20 mx-auto" />
            </div>

            {/* Summary skeleton */}
            <div className="mb-6">
                <div className="skeleton skeleton-text w-24 mb-3" />
                <div className="skeleton skeleton-text w-full" />
                <div className="skeleton skeleton-text w-full" />
                <div className="skeleton skeleton-text w-3/4" />
            </div>

            {/* Missing points skeleton */}
            <div className="mb-6">
                <div className="skeleton skeleton-text w-32 mb-3" />
                <div className="flex items-center gap-2 mb-2">
                    <div className="skeleton skeleton-circle w-5 h-5 flex-shrink-0" />
                    <div className="skeleton skeleton-text w-full mb-0" />
                </div>
                <div className="flex items-center gap-2 mb-2">
                    <div className="skeleton skeleton-circle w-5 h-5 flex-shrink-0" />
                    <div className="skeleton skeleton-text w-4/5 mb-0" />
                </div>
            </div>

            {/* Tips skeleton */}
            <div className="mb-6">
                <div className="skeleton skeleton-text w-40 mb-3" />
                <div className="skeleton h-16 w-full mb-2 rounded-lg" />
                <div className="skeleton h-16 w-full rounded-lg" />
            </div>

            {/* Full mark answer skeleton */}
            <div>
                <div className="skeleton skeleton-text w-36 mb-3" />
                <div className="skeleton h-24 w-full rounded-lg" />
            </div>
        </div>
    );
}
